import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material';


@Component({
  selector: 'app-myreferral-view-dialog',
  templateUrl: './myreferral-view-dialog.component.html',
  styleUrls: ['./myreferral-view-dialog.component.css']
})
export class MyreferralViewDialogComponent implements OnInit {


  viewdata: any;

  constructor(
    private dialogRef: MatDialogRef<MyreferralViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: any,
    ) {
      dialogRef.disableClose = true;
      }

    ngOnInit() {
    this.viewdata = this._data.element;
    
  }

  close() {
    this.dialogRef.close();
  }
}
